// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"8f51288a","453":"72afe255","821":"68aa4658"}[chunkId] + ".chunk.js";
};